var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowUp = function ArrowUp(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M13 19a1 1 0 1 1-2 0V7.135l-4.36 3.633a1 1 0 1 1-1.28-1.536l5.986-4.989a.993.993 0 0 1 .855-.223.99.99 0 0 1 .453.223l5.986 4.989a1 1 0 1 1-1.28 1.536L13 7.135V19Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ArrowUp;